export default "static/media/sorting-algos.c199172.svg"